var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "RegistTextAgreement" }, [
      _c("div", { staticClass: "title" }, [
        _c("h2", [_vm._v("商维宝法律声明")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("h4", { staticClass: "subtitle" }, [_vm._v("版权")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            本网站包含之所有内容：文本、图形、LOGO、创意、及软件等之所有权归属商维宝及本网站的内容/信息提供者，受中国及国际版权法的保护。对本网站上所有内容之复制（意指收集、组合和重新组合），本网站享有排他权并受中国及国际版权法的保护。本网站使用的所有软件的所有权归属于商维宝或它的软件供应商并受中国及国际版权法的保护。在本网站上的内容和软件可以用作信息获取网上交易及网上拍卖的信息资源，对本网站该等内容的任何其他使用，包括再造、修改、发布、转发、再版、演示或播出被严格禁止。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("商标")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            商维宝；商维宝.com  商维宝.cn  51rbm.com 51rbm.cn  rbmone.com  rbmone.cn  sweib.com  shangwb.com及其他商维宝的图形、图片、图表、声音、创意、LOGO和服务名称、标识均受相关法律保护，该等商标、专有名称、标识等不能在任何非属商维宝的产品或服务上进行容易在客户中引起混淆或引起歧义的使用，或以任何曲解或诋毁商维宝之形式使用。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("网站使用")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "商维宝及其任何组成部分不得被再造、复制、抄袭、交易，或为任何未经商维宝允许的商业目的所使用。如果商维宝确定客户行为违法或有损其网站和企业的利益，则商维宝和其关联企业将保留，包括但不限于拒绝提供服务、冻结会员专有帐户、和/或取消定单的权利。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("评论")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            商维宝允许访问客户将其对产品的评论在商维宝上发表个性化意见。如果您在本网站上发表评论，您即授权商维宝和他的关联企业在世界范围内的任何媒体上享有非排他，永久，不可更改及完全的许可权利去使用、重新加工、修改、采用、出版、翻译、派生、分发及播出该评论。你同时授权商维宝和他的关联企业授权使用者可以引用你发表评论时的署名，并如果有，可以附你发表的评论。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("链接")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "商维宝上的链接服务可以直接进入其他站点，这些链接的站点不受商维宝的控制，商维宝对任何与本站链接网站的内容不负责任。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("版权投诉")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "商维宝和他的关联企业尊重他人之知识产权。如果你确认你的作品以某种方式被抄袭，该行为触犯了中国及国际版权法，请向商维宝做版权投诉。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("免责")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            商维宝对本网站上所有内容包括但不限于网站运营或本网站上的信息、内容、材料或产品，不提供明示或暗示的担保。由所适用法律许可，商维宝否认所有明示或暗示的担保，包括但不限于为特定目的做的商务暗示担保。商维宝对任何损失或任何由于使用本网站而引起的损失，包括但不限于直接的，间接的，偶然的、惩罚性的和引发的损失，不承担责任。"
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("1、会员注册名、密码和保密。")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他商维宝允许的方式实际使用商维宝网站服务时，您即成为商维宝会员（亦称会员），商维宝根据会员注册名和密码确认您的身份。您须自行负责对您的会员注册名和密码保密，且须对您在会员注册名和密码下发生的所有活动（包括但不限于发布信息资料、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。您同意：(a) 如发现任何人未经授权使用您的会员注册名或密码，或发生违反保密规定的任何其他情况，您会立即通知商维宝；(b) 确保您在每个上网时段结束时，以正确步骤离开网站。商维宝不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。您理解商维宝对您的请求采取行动需要合理时间，商维宝对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。"
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("2、处理交易争议。")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            商维宝不涉及用户间因交易而产生的法律关系及法律纠纷，不会且不能牵涉进交易各方的交易当中。倘若您与一名或一名以上用户，或与您通过本公司网站获取其服务的第三者服务供应商发生争议，您免除商维宝 (及本公司代理人和雇员) 在因该等争议而引起的，或在任何方面与该等争议有关的不同种类和性质的任何 (实际和后果性的) 权利主张、要求和损害赔偿等方面的责任。"
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("3、商维宝网站仅作为交易地点。")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            本公司网站仅作为用户物色交易对象，就货物和服务的交易进行协商，以及获取各类与贸易相关的服务的地点。但是，本公司不能控制交易所涉及的物品的质量、安全或合法性，商贸信息的真实性或准确性，以及交易方履行其在贸易协议项下的各项义务的能力。本公司不能也不会控制交易各方能否履行协议义务。此外，您应注意到，与外国国民、未成年人或以欺诈手段行事的人进行交易的风险是客观存在的。"
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("操作规则")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            下面的条款和前面所述的条款均适用于本网站上的论坛，讨论组，聊天组，公告板和任何在网站上发生有相互影响作用区域的行为。网上用户使用、进入或参与上述区域或网站上的任何其他具相互影响作用区域，则表示同意所有这些条款。您参与的在线沟通是实时发生的，没有经过任何来自本网站的编辑、压缩、或任何其他形式的控制。本网站不能也没有甄别所有网站用户提供的内容。但本网站保留对本网站上内容的监控权，并对本网站认为具有危害性，引起争议性的或违反本操作规则的其他内容进行删除的权利。为了提供满足本网站用户需求的高价值信息的服务，并避免本网站用户遭受因对他人权利的不实、恶意攻击或其他有害陈述而引起的损失，本网站有必要建立下列操作规则以避免本网站之被滥用："
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("当您使用本网站服务时，您不可以：")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "1） 粘贴或传播任何非法的，具威胁性的，诽谤性的，贬损的，报复的、亵渎的或任何其他法律禁止的信息，包括但不限于传播任何煽动性鼓励犯罪的，或违反公民义务或任何其他违反地方法规、国家法律、法规或国际法律、惯例或公约的内容；"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "2） 粘贴或传播任何散布任何他人的私人事件，粘贴或传播带有病毒，或任何带有贬损或损害性特征的内容；"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "3） 粘贴或传播任何可能侵害其他人财产权利的数据、图形或程序，包括以非法形式使用未经注册的版权文本、图形或程序，商业秘密及其他保密信息、商标、服务标识等；"
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("4） 以任何形式干扰本网站的其他用户。")]),
        _vm._v(" "),
        _c("h4", { staticClass: "subtitle" }, [_vm._v("适用法律")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "商维宝（retail.sweib.com  vend.sweib.com  serv.sweib.com）由南京商维宝科技有限公司运营和控制，适用中华人民共和国法律。我们保留随时更改我们的网站和上述免责及条款的权利。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-299d3040", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-299d3040","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/RegistPubAgreement.vue
// module id = 1754
// module chunks = 1